import React, { useEffect } from "react";
import "./Wishlist.css";
import Breadcrumb_comp from "../common-components/breadcrumb-comp/Breadcrumb_comp";
import Product_card from "../common-components/product_card/Product_card";
import {
  getAllWishlist,
  postWishlist,
} from "../../features/wishlist/wishlistSlice";
import { useDispatch, useSelector } from "react-redux";
import Product_Info_Card from "../common-components/product_info_card/Product_Info_Card";
import { formatDate, RolesIds, variant_type } from "../../utils/common";
import Product_Info_Table from "./Product_Info_Table/Product_Info_Table";
import Product_Info_Mobile_Card from "./Product_Info_Mobile_Card/Product_Info_Mobile_Card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

function Wishlist() {
  const allWishlist = useSelector((state) => state.wishlist.allWishlist);
  const dispatch = useDispatch();

  const isSignIn = useSelector((state) => state.auth.is_signin);

  useEffect(() => {
    if (isSignIn) dispatch(getAllWishlist());
  }, [dispatch, isSignIn]);
  const postWishlistData = async (data) => {
    const res = await dispatch(postWishlist({ product_id: data }));

    if (res.meta?.requestStatus === "fulfilled") {
      await dispatch(getAllWishlist());
    } else if (res.meta?.requestStatus === "rejected") {
    }
  };

  const user = useSelector((state) => state.myaccount.addMyaccount);
  const isVendor =
    user?.role_id && Number(user?.role_id) === Number(RolesIds.Vendor);

  const navigate = useNavigate();

  return (
    <>
      <section className="Wishlist ">
        <div className="container">
          <div className="back_holder" onClick={() => navigate(-1)}>
            <FontAwesomeIcon icon={faArrowLeft} className="back_icon" />
            <span>Back</span>
          </div>
          <div className="">
            <div className="heading_holder">
              <h4 className="heading_text">Wishlist</h4>
            </div>
            <div className="wishlist_table_wrapper">
              <div className="wishlist_desktop">
                <table className="wishlist_table">
                  <thead>
                    <tr>
                      <th className="p-head">Product Image</th>
                      <th>Date Added</th>
                      <th>Unit Price</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody className="wishlist-body">
                    {allWishlist?.data?.length > 0 ? (
                      allWishlist?.data?.map((product, index) => {
                        let metal;
                        let size;
                        let triple;

                        if (
                          Number(product?.Product?.variant_type_id) ===
                          Number(variant_type.Single)
                        ) {
                          metal = product.Product?.Product_Variants[0];
                        } else if (
                          Number(product?.Product?.variant_type_id) ===
                          Number(variant_type.Double)
                        ) {
                          metal = product.Product?.Product_Variants[0];
                          size = metal?.Double_Variants?.[0];
                        } else if (
                          Number(product?.Product?.variant_type_id) ===
                          Number(variant_type.Triple)
                        ) {
                          metal = product.Product?.Product_Variants[0];
                          size = metal?.Double_Variants?.[0];
                          triple = size?.Triple_Variants?.[0];
                        }

                        const activeVariant = triple || size || metal;

                        return (
                          <Product_Info_Table
                            activeVariant={activeVariant}
                            isVendor={isVendor}
                            key={index}
                            product={product?.Product}
                            id={product?.Product?.id}
                            imgSrc={
                              process.env.REACT_APP_IMG_URL +
                              product?.Product?.image
                            }
                            productName={product.Product?.name}
                            priceText={
                              isVendor
                                ? activeVariant?.b2b_price
                                : activeVariant?.price || 0
                            }
                            addedDate={formatDate(product?.createdAt)}
                            onDelete={postWishlistData}
                          />
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="4" className="empty_text text-center">
                          Product Not Available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="wishlist_mobile">
                {allWishlist?.data?.map((product, index) => {
                  let metal;
                  let size;
                  let triple;

                  if (
                    Number(product?.Product?.variant_type_id) ===
                    Number(variant_type.Single)
                  ) {
                    metal = product.Product?.Product_Variants[0];
                  } else if (
                    Number(product?.Product?.variant_type_id) ===
                    Number(variant_type.Double)
                  ) {
                    metal = product.Product?.Product_Variants[0];
                    size = metal?.Double_Variants?.[0];
                  } else if (
                    Number(product?.Product?.variant_type_id) ===
                    Number(variant_type.Triple)
                  ) {
                    metal = product.Product?.Product_Variants[0];
                    size = metal?.Double_Variants?.[0];
                    triple = size?.Triple_Variants?.[0];
                  }

                  const activeVariant = triple || size || metal;

                  return (
                    <Product_Info_Mobile_Card
                      activeVariant={activeVariant}
                      isVendor={isVendor}
                      key={index}
                      product={product?.Product}
                      imgSrc={
                        process.env.REACT_APP_IMG_URL + product?.Product?.image
                      }
                      productName={product.Product?.name}
                      priceText={
                        isVendor
                          ? activeVariant?.b2b_price
                          : activeVariant?.price || 0
                      }
                      addedDate={formatDate(product?.createdAt)}
                      onDelete={postWishlistData}
                      activeVariant={activeVariant}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Wishlist;
